import type { WorkLog } from '@/services/api/workLogs'

import { MOCK_EMPLOYEE_ID } from './seed'

/** Work-log fixtures cross-referencing seed.ts employees. */

export const mockWorkLogs: WorkLog[] = [
  {
    id: 'work-log-1',
    employeeId: MOCK_EMPLOYEE_ID,
    date: '2025-06-30',
    clockIn: '08:00',
    clockOut: '16:30',
    totalHours: 8.5,
    jobsCompleted: 4,
    notes: 'Standard shift',
    createdAt: '2025-06-30T08:00:00Z',
    updatedAt: '2025-06-30T16:30:00Z',
  },
  {
    id: 'work-log-2',
    employeeId: 'employee-2',
    date: '2025-06-30',
    clockIn: '07:30',
    clockOut: '15:30',
    totalHours: 8,
    jobsCompleted: 5,
    createdAt: '2025-06-30T07:30:00Z',
    updatedAt: '2025-06-30T15:30:00Z',
  },
  {
    id: 'work-log-3',
    employeeId: 'employee-3',
    date: '2025-06-30',
    clockIn: '09:00',
    totalHours: undefined,
    jobsCompleted: 2,
    notes: 'Still clocked in',
    createdAt: '2025-06-30T09:00:00Z',
    updatedAt: '2025-06-30T09:00:00Z',
  },
]
